import { render, staticRenderFns } from "./CompensationProcedureReport.vue?vue&type=template&id=826040c4&scoped=true"
import script from "./CompensationProcedureReport.vue?vue&type=script&lang=js"
export * from "./CompensationProcedureReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826040c4",
  null
  
)

export default component.exports